export const sitesWebMisc = {
  // NombreEditable.vue — inline-editable website name field
  ne: {
    aria: "O nome do seu site",
    placeholder: "Minha acomodação",
    hint: "Enter para salvar · Esc para cancelar",
  },

  // website/index.vue — website creation wizard
  website: {
    next: "Avançar",
  },

  // Notificaciones/index.vue — notifications timeline
  notif: {
    title: "Notificações",
    subtitle: "Tudo o que aconteceu em suas acomodações, em ordem cronológica.",
    // Filters
    filterAll: "Todas",
    filterBookings: "Reservas",
    filterCheckins: "Check-ins",
    filterServices: "Serviços",
    filterPayments: "Pagamentos",
    // Empty state
    emptyAll: "Ainda não há notificações",
    emptyFilter: "Nenhuma notificação neste filtro",
    emptyBody:
      "Quando algo acontecer com suas reservas —uma nova, um check-in, um pagamento— aparecerá aqui.",
    // Day separators
    noDate: "Sem data",
    today: "Hoje",
    yesterday: "Ontem",
    // Event status (left column)
    stNueva: "Nova",
    stActualizada: "Atualizada",
    stCancelada: "Cancelada",
    stRealizado: "Concluído",
    stSolicitado: "Solicitado",
    stRecibida: "Recebida",
    stAprobada: "Aprovada",
    stRechazada: "Rejeitada",
    stConfirmado: "Confirmado",
    stEnProceso: "Pagamento em andamento",
    stAviso: "Aviso",
    // Event category (subtitle)
    catReserva: "reserva",
    catCheckin: "check-in",
    catServicio: "serviço",
    catSolicitud: "solicitação",
    catPago: "pagamento",
    catPagoPendiente: "pagamento pendente",
    catSistema: "sistema",
    // Descriptive event-type labels
    lbNuevaReserva: "Nova reserva",
    lbReservaActualizada: "Reserva atualizada",
    lbReservaCancelada: "Reserva cancelada",
    lbCheckin: "Check-in",
    lbServicio: "Serviço",
    lbSolicitud: "Solicitação",
    lbSolicitudAprobada: "Solicitação aprovada",
    lbSolicitudRechazada: "Solicitação rejeitada",
    lbPago: "Pagamento",
    lbNotificacion: "Notificação",
  },

  // Integrations/index.vue — integrations with external services
  integrations: {
    title: "Integrações",
    subtitle: "Conecte serviços externos para agilizar a gestão",
    descPricelabs: "Otimização dinâmica de preços",
    descStripe: "Pagamentos com cartão dos hóspedes",
    descWompi: "Pagamentos de hóspedes na Colômbia",
    connected: "Conectado",
    disconnected: "Não conectado",
  },
};
